import { RouterContext } from '~/types/router.type';

import { fetchCallOff, queryKeysCallOff } from '~/data/callOff';

export async function getCallOff({
  context,
  params,
}: {
  context: RouterContext;
  params: { callOffId: string };
}) {
  const { callOffId } = params;
  const { queryClient } = context;

  let callOffNumber = '';
  try {
    const data = await queryClient.fetchQuery({
      queryKey: queryKeysCallOff.get(callOffId),
      queryFn: async () => fetchCallOff(callOffId),
    });
    callOffNumber = data?.calloffNumber ?? '';
  } catch (error) {
    // Don't throw so we can show a specific error page in case the call-off is not found
  }

  return {
    ...context,
    pageData: {
      title: callOffNumber,
    },
  };
}
